import { Button, ButtonType } from "@/components/common/button";
import { SUPPORT_PHONE, SUPPORT_PHONE_LINK } from "@/constants/support";
import { QuizQuestionProps } from "@/pages/quiz/context/types";

const MonthlyCheckInSupportQuestion = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => (
  <div>
    <p className="m-0 lg:text-[17px] text-base leading-6 text-black">
      You told us you&apos;re really struggling with side effects. Call Customer
      Support at{" "}
      <a
        href={SUPPORT_PHONE_LINK}
        className="font-bold text-dark-purple-2 underline whitespace-nowrap"
      >
        {SUPPORT_PHONE}
      </a>{" "}
      so the care team can help you right away. Your answers are saved — you can
      finish your check-in after the call.
    </p>

    <div className="mt-3 rounded-md border-l-4 border-[#F2C94C] bg-[#FFF4D6] px-4 py-3.5 text-base leading-6 text-[#171717]">
      <strong>If this is a medical emergency</strong> — for example chest pain,
      trouble breathing, severe or repeated vomiting, or fainting — call 911 or
      go to the nearest emergency room.
    </div>

    <a
      href={SUPPORT_PHONE_LINK}
      className="mt-4 flex h-[60px] lg:h-[68px] items-center justify-center rounded-full bg-yellow px-6 text-center text-[20px] font-bold leading-none text-black no-underline"
    >
      Call {SUPPORT_PHONE}
    </a>

    <Button
      type={ButtonType.CONTINUE}
      label="Continue"
      onClick={() => setQuestionAnswer(true)}
    />
  </div>
);

export { MonthlyCheckInSupportQuestion };
